import { DeleteOutlined, DownloadOutlined, DownOutlined, EditOutlined, EyeOutlined, PlusOutlined, SearchOutlined, UploadOutlined } from '@ant-design/icons';
import { Breadcrumb, ConfigProvider, Input, Pagination, Select, Switch } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import * as categoryCarApi from '../../../api/categoryCar/categoryCarApi';
import * as typeVehicleApi from '../../../api/typeVehicle/typeVehicleApi';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import useDebounce from '../../../hook/useDebounce';
import useToast from '../../../hook/useToast';
import Layout from '../../../Layout';
import './style.scss';

import viVN from 'antd/locale/vi_VN';
import { API_URL, URL_CAR_CATEGORY } from '../../../env';
import useThrottle from '../../../hook/useThrottle';

import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { PaginationProps } from 'antd/es/pagination/Pagination';
import { useSelector } from 'react-redux';
import { avatarDefault, noData } from '../../../components/ExportImgFigma';
import useLoading from '../../../hook/useLoading';
import { selectorMenu } from '../../../store/slices/menuSlice';
import { checkDisabledPermission, dataPagination, findChildIdByUrl, fommatSelectOption, getUserPermissions } from '../../../until';
import ImportDataColorCar from '../../Customers/Component/ImportDataModal/ImportDataColorcar';
import StatusCellRenderer from '../VehicleTypeManagement/Component/StatusCellRenderer';
import ModalEdit from './Component/Modal/ModalEdit';
import ModalView from './Component/Modal/ModalView';
import ModalCreate from './Component/Modal/ModalCreate';
import { activeVehicleGroup, deleteProduct, getInfoProduct, IProduct, updateActiveProduct } from '../../../api/carProduct/carProductApi';
import { getCLCarLines, getCLTypeVehicle } from '../../../api/selectOption/selectOptionsApi';
import { ISelectOption } from '../../../api/selectOptions/selectOptionsApi';
import { NodataTable } from '../../../components/NoDataTable';
import { deleteProductGroup, getInfoProductGroup, getListProductGroup, IProductGroup } from '../../../api/carProductGroup/carProductGroupApi';
import { formatNumber } from '../../../services/mixin';
import { useLocation } from 'react-router-dom';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { activeArray } from '../../../api/unit/unitApi';

interface IDataDefaulFilterList {
  carLineId?: number
  typeVehicleId?: number
  groupVehicleId?: number
  search?: string;
}
const dataDefaulFilterList = {
};


const ProductManagement: React.FC = () => {
  const pushToast = useToast();
  const pushLoading = useLoading()
  const menuSlice = useSelector(selectorMenu)

  useEffect(() => {

    gCLCarLines()
    gCLTypeVehicle()

    return () => {
      setDataFilterList(dataDefaulFilterList)
      setPagination({ current: 1, pageSize: 20, total: 0 })
      setSelectedRowKeys([])
    }
  }, [])



  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [openModalUpload, setOpenModalUpload] = useState(false);
  const location = useLocation();
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, download, upload } = getUserPermissions(permissionSlice, location.pathname)



  // bộ lọc
  const [fileData, setFileData] = useState({} as any)

  const [type, setType] = useState<string>("")

  const [isOpenModalAdd, setIsOpenModalAdd] = useState(false)
  const [isOpenModalView, setIsOpenModalView] = useState(false)
  const [isOpenModalEdit, setIsOpenModalEdit] = useState(false)
  const [isModalDelete, setIsModalDelete] = useState(false)

  const [dataFilterList, setDataFilterList] = useState<IDataDefaulFilterList>(dataDefaulFilterList)

  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  const [cLCarLines, setCLCarLines] = useState<ISelectOption[]>([])
  const [cLTypeVehicle, setCLTypeVehicle] = useState<ISelectOption[]>([])

  const [idChose, setIdChose] = useState<number[]>();

  const [infoProductGroup, setInfoProductGroup] = useState<IProductGroup>()

  const [listProductGroup, setListProductGroup] = useState<IProductGroup[]>([])


  const actionColumn: ColDef = {
    headerName: 'Hành động',
    headerComponentParams: {
      template: '<span class="w-full flex items-center justify-center">Hành động</span>'
    },
    field: 'action',
    colId: 'action',
    width: 180,
    resizable: false,
    suppressMovable: true,
    lockPosition: 'left',
    cellRenderer: (params: any) => {
      const id = params.data.id
      const groupPermissionId = params.data.permissionMenu?.groupPermissionId
      // const { view, edit, delete: isDelete } = params?.data?.permissionMenu
      return (
        <div className='d-flex gap-4 justify-center align-center  h-full'>
          <EyeOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
            onClick={() => gInfoProductGroup(id)}
          />
          <EditOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
            onClick={() => gInfoProductGroup(id, false)}
          />
          <DeleteOutlined
            className={`text-F5222D text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(isdelete)}`}
            onClick={() => openModalDelete(Number(id))}
          />
        </div>
      )
    },
  }

  const columnDefs = useMemo<ColDef<IProductGroup>[]>(() => [
    actionColumn,
    {
      headerName: "Dòng xe",
      field: "carLineTitle",
      sortable: true,
      flex: 1,
    },
    {
      headerName: "Thương hiệu",
      field: "categoryCarTitle",
      sortable: true,
      flex: 1,
    },
    {
      headerName: "Mã nhóm sản phẩm",
      field: "code",
      sortable: true,
      flex: 1,
    },
    {
      headerName: "Tên nhóm sản phẩm",   // field "title" trong interface Daum
      field: "title",
      sortable: true,
      flex: 1,
    },
    // {
    //   headerName: "Trạng thái",
    //   field: "status",
    //   sortable: true,
    //   cellRenderer: StatusCellRenderer,
    //   cellRendererParams: {
    //     onToggle: (id: number, isActive: boolean) => uActiveCategoryCar(id, isActive),
    //     idKey: "id",
    //   },
    //   flex: 1,
    // },
    {
      headerName: "Trạng thái",
      field: "status",
      sortable: true,
      cellRenderer: (params: ICellRendererParams) => {
        const { id, status } = params.data;
        return (
          <div className="d-flex align-center gap-10-px">
            <Switch
              defaultChecked={!!status}
              onChange={() => uActiveCategoryCar(Number(id))}
              className={`rs-switch rs-switch--sm   ${checkDisabledPermission(edit)}`}
            />
            <p className="font-medium fw-500 text-344054">
              {activeArray[status ? 1 : 0]}
            </p>
          </div>
        );
      },
      flex: 1
    },
  ], [pagination]);


  const gCLCarLines = async () => {
    const result = await getCLCarLines()
    if (result?.status) {
      setCLCarLines(fommatSelectOption(result.data))
    }
  }

  const gCLTypeVehicle = async () => {
    const result = await getCLTypeVehicle()
    if (result?.status) {
      setCLTypeVehicle(fommatSelectOption(result.data))
    }
  }

  const gListProductGroup = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const { search, carLineId, typeVehicleId, groupVehicleId } = dataFilterList

    const result = await getListProductGroup(
      pageSize, pageCurent, search, carLineId,
      typeVehicleId
    )
    if (result?.status) {
      setListProductGroup(result.data)
      setPagination({ current: pageCurent, total: result.total, pageSize })
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)


  const gInfoProductGroup = useThrottle(async (id: number, isview: boolean = true) => {
    pushLoading(true)
    const result = await getInfoProductGroup(
      id
    )
    if (result?.status) {
      setInfoProductGroup(result.data)
      if (isview)
        setIsOpenModalView(true)
      else
        setIsOpenModalEdit(true)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const uActiveCategoryCar = useThrottle(async (id: number, isActive: boolean) => {
    pushLoading(true)
    const result = await activeVehicleGroup(
      id
    )
    if (result?.status) {
      gListProductGroup(pagination.current, pagination.pageSize)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setIsOpenModalAdd(false)
      pushToast(message, "success")
      gListProductGroup(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "error")
    }
  }

  const onSubmitFormModalEdit = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setIsOpenModalEdit(false)
      pushToast(message, "success")
      gListProductGroup(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "error")
    }
  }

  const onSubmitFormModalDelete = async () => {
    if (!idChose) return
    const result = await deleteProductGroup(idChose)
    if (result.status) {
      setIsModalDelete(false)
      pushToast(result.message, "success")
      gListProductGroup(pagination.current, pagination.pageSize)
    } else {
      pushToast(result.message, "error")
    }
  }

  const openModalDelete = (id: number) => {
    setIdChose([id])
    setIsModalDelete(true)
  }

  const closeModalDelete = () => {
    setIdChose(undefined)
    setIsModalDelete(false)
  }

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gListProductGroup(pageNumber, pageSize)
  }

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleUpload = async (type: string): Promise<typeVehicleApi.ResponseSuccessDataError> => {
    setType(type)
    const result = await typeVehicleApi.uploadFileCategoryCar(fileData)
    if (result?.status) {
      pushLoading(true)
    }
    return result
  }
  const handleFile = (file: any) => {
    setFileData(file)
  }

  useEffect(() => {
    gListProductGroup()
  }, [dataFilterList])

  return (

    <Layout>
      {/* <ImportDataColorCar
        show={openModalUpload}
        fileData={fileData}
        linkExamplPre={`${API_URL}uploads/fileExcel/car/Danhsachthuonghieu.xlsx`}
        type={"dataCategoryError"}

        setFileData={setFileData}
        handleUpload={() => handleUpload(type)}
        handleFile={handleFile}
        gListCarColor={gListProduct}
        modalClose={() => setOpenModalUpload(false)}
      /> */}

      <ModalCreate
        isOpen={isOpenModalAdd}
        onSubmitFormModal={onSubmitFormModalAdd}
        closeModal={() => setIsOpenModalAdd(false)}
      />

      <ModalView
        isOpen={isOpenModalView}
        infoProductGroup={infoProductGroup}
        closeModal={() => setIsOpenModalView(false)}
      />

      <ModalEdit
        isOpen={isOpenModalEdit}
        infoProductGroup={infoProductGroup}
        onSubmitFormModal={onSubmitFormModalEdit}
        closeModal={() => setIsOpenModalEdit(false)}
      />

      <ModalDeleteManager
        isOpen={isModalDelete}
        title="Bạn có chắc chắn xóa nhóm sản phẩm này"
        titleDelete="Xóa nhóm sản phẩm"
        content="Nhóm sản phẩm và dữ liệu liên quan sẽ bị xóa vĩnh viễn
      không thể khôi phục"
        onConfirm={onSubmitFormModalDelete}
        closeModal={closeModalDelete}
      />

      <Breadcrumb
        items={[
          {
            title: 'THACO AUTO CRM',
          },
          {
            title: <a href="/">Quản lý danh mục xe</a>,
          },
          {
            title: 'Quản lý nhóm sản phẩm',
          },
        ]}
      />
      <div className='title-page'>
        Quản lý nhóm sản phẩm
      </div>
      <div className='d-flex gap-3 pb-18-px brand-management-filter'>
        <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3  py-1 h-8 justify-between overflow-hidden">
          <Input
            placeholder="Tìm kiếm theo tên nhóm sản phẩm"
            className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
            value={dataFilterList.search}
            onChange={(e) => setDataFilterList({ ...dataFilterList, search: e.target.value })}
          />
          <div className=" border-l-F2F4F7 h-full d-flex align-center">
            <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
          </div>
        </div>
        <div className='d-flex align-center gap-2'>
          <div className="w-200-px border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
            <div className="d-flex align-center  w-full">
              <Select
                showSearch
                allowClear
                className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                popupClassName='position-dropdow custome-select-item h-popUp'
                variant="borderless"
                placeholder="Chọn dòng xe"
                suffixIcon={null}
                options={cLCarLines}
                value={dataFilterList.carLineId}
                onChange={(e) => setDataFilterList({ ...dataFilterList, carLineId: e })}
              />

            </div>
            <div className="  h-full d-flex align-center">
              <DownOutlined className="text-sm text-98A2B3 " />
            </div>
          </div>
        </div>
        <div className='d-flex align-center gap-2'>
          <div className="w-200-px border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
            <div className="d-flex align-center  w-full">
              <Select
                showSearch
                allowClear
                className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                popupClassName='position-dropdow custome-select-item h-popUp'
                variant="borderless"
                placeholder="Chọn loại xe"
                suffixIcon={null}
                options={cLTypeVehicle}
                value={dataFilterList.typeVehicleId}
                onChange={(e) => setDataFilterList({ ...dataFilterList, typeVehicleId: e })}
              />

            </div>
            <div className="  h-full d-flex align-center">
              <DownOutlined className="text-sm text-98A2B3 " />
            </div>
          </div>
        </div>
        <button
          className={`border-EAECF0 bg-white rounded-6-px w-106-px py-2 px-4 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save ${checkDisabledPermission(download)}`}
        // onClick={selectedRowKeys.length ? glistSelectedExel : glistByExcel}
        >
          <DownloadOutlined className='text-sm text-344054' />
          <span className='text-sm fw-400 font-regular text-344054 white-space-nowrap'>Xuất DS</span>
        </button>
        <button
          className={`border-EAECF0 bg-white rounded-6-px w-111-px py-2 px-4 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save ${checkDisabledPermission(upload)}`}
          onClick={() => setOpenModalUpload(true)}
        >
          <UploadOutlined className='text-sm text-344054' />
          <span className='text-sm fw-400 font-regular text-344054 white-space-nowrap'>Nhập DS</span>
        </button>
        <button className={`border-none bg-096DD9 rounded-6-px  py-2 px-4 h-8 d-flex justify-center align-center gap-10-px w-107-px ${checkDisabledPermission(add)}`}
          onClick={() => setIsOpenModalAdd(true)}
        >
          <PlusOutlined className='text-sm text-white' />
          <span className='text-sm fw-400 font-regular text-white white-space-nowrap'>Tạo mới</span>
        </button>
      </div>
      <div className="t-table-block  custom-page-css flex flex-col flex-1 justify-between">
        <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
          <AgGridReact
            rowSelection="multiple"
            rowData={listProductGroup}
            columnDefs={columnDefs}
            className="my-auto-height-grid"
            rowHeight={55}
            getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            overlayNoRowsTemplate={NodataTable}
            suppressDragLeaveHidesColumns={true}
          />

        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination
              showSizeChanger
              pageSize={pagination.pageSize}
              total={pagination.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}

            />
          </div>
        </ConfigProvider>
      </div>
    </Layout>

  );
}

export default ProductManagement;
